const IPM_FACTOR = 2362.206;

export const convertMetersPerSecond = {
  toInchesPerMinute: (mps: number) => mps * IPM_FACTOR,
  fromInchesPerMinute: (ipm: number) => ipm / IPM_FACTOR,
};
